import { createSlice } from "@reduxjs/toolkit";
import {
  createExtraReducersForThunk,
  createApiThunkPrivate,
} from "../_helpers/ApiThunk";

const initialState = {
  getNotificationData: {},
};

export const getNotification = createApiThunkPrivate(
  "getNotification",
  "/notification/getNotificaion",
  "POST"
);

export const markAsReadNotification = createApiThunkPrivate(
  "markAsread",
  "/notification/markAsread",
  "PUT"
);

export const markAllAsReadNotification = createApiThunkPrivate(
  "markAllread",
  "/notification/markAllread",
  "PUT"
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  extraReducers: (builder) => {
    createExtraReducersForThunk(
      builder,
      getNotification,
      "getNotificationData"
    );
  },
});

export default notificationSlice.reducer;
